"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _button = require("@design/ui/button");
var _dropdownMenu = require("@design/ui/dropdown-menu");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function RemedyVariantPicker(_ref) {
  var variants = _ref.variants,
    selectedVariantId = _ref.selectedVariantId,
    onVariantSelect = _ref.onVariantSelect;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-row items-center h-6 flex-[0_1_auto] min-w-0 mr-2 ml-auto",
    "data-sentry-component": "RemedyVariantPicker",
    "data-sentry-source-file": "RemedyVariantPicker.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "box-border flex flex-row justify-start items-center py-2.5 pl-2.5 pr-1 gap-2.5 h-6 flex-[1_1_auto] min-w-0 self-stretch overflow-hidden",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "min-w-0 flex-auto truncate text-body-sm text-foreground-primary",
        children: selectedVariantId
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dropdownMenu.DropdownMenu, {
      "data-sentry-element": "DropdownMenu",
      "data-sentry-source-file": "RemedyVariantPicker.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuTrigger, {
        asChild: true,
        "data-sentry-element": "DropdownMenuTrigger",
        "data-sentry-source-file": "RemedyVariantPicker.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
          variant: "ghost",
          size: "icon-xs",
          disabled: variants.length <= 1,
          "aria-label": "Remedy plan options",
          "data-sentry-element": "Button",
          "data-sentry-source-file": "RemedyVariantPicker.tsx",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.KeyboardArrowDownIcon, {
            "data-sentry-element": "KeyboardArrowDownIcon",
            "data-sentry-source-file": "RemedyVariantPicker.tsx"
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuContent, {
        className: "w-auto",
        "data-sentry-element": "DropdownMenuContent",
        "data-sentry-source-file": "RemedyVariantPicker.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuRadioGroup, {
          value: selectedVariantId,
          onValueChange: onVariantSelect,
          "data-sentry-element": "DropdownMenuRadioGroup",
          "data-sentry-source-file": "RemedyVariantPicker.tsx",
          children: variants.map(function (variant) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuRadioItem, {
              value: variant,
              children: variant
            }, variant);
          })
        })
      })]
    })]
  });
}
var _default = exports.default = RemedyVariantPicker;